module.exports = __webpack_public_path__ + "img/code-icon-white.682fd819.svg";